module.exports = __webpack_public_path__ + "img/plat3.28b05c3a.png";